export const ADDPRODUCT = "products/addProduct";
export const ADDTOCART = "products/addToCart";
export const INCREMENT = "products/increment";
export const DECREMENT = "products/decrement";
export const REMOVE = "products/remove";
